<template>
  <div class="col-12">
    <table class="table table-bordered bg-white table-sm">
      <tbody>
        <tr>
          <td colspan="2">
            Usuário(s) Atendido(s):
            <b
              class="badge badge-light mr-2"
              v-for="pessoa in atendimento.pessoas_objetos"
              :key="pessoa.id"
            >
              {{
                pessoa.nome_social ? pessoa.nome_social : pessoa.nome_completo
              }}
            </b>
          </td>
        </tr>
        <tr>
          <td>
            ID:<b>{{ atendimento.id }}</b> Protocolo:<b>{{
              atendimento.protocolo
            }}</b>
          </td>
          <td>
            Criado:
            <strong v-if="atendimento.data_cadastro_formatado">
              {{ atendimento.data_cadastro_formatado }}
            </strong>
            <strong v-else>{{ atendimento.cadastrado }}</strong>
          </td>
        </tr>
        <tr>
          <td>
            Técnico responsável:
            <b v-if="atendimento.responsavel">{{
              atendimento.responsavel.name
            }}</b>
            <span v-if="atendimento.responsavel" class="badge badge-light">
              {{ atendimento.responsavel.tecnico.profissao ?? "Não informado" }}
            </span>
          </td>
          <td>
            Atualizado: <b>{{ atendimento.atualizado }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Técnico autor:
            <b>{{ atendimento.autor }}</b>
          </td>
          <td>
            Unidade:
            <b v-if="atendimento.unidade">{{ atendimento.unidade.nome }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Outro(s) Técnico(s):
            <b
              class="badge badge-light mr-2"
              v-for="(tecnico, index) in atendimento.outros_tecnicos"
              :key="index"
            >
              {{ tecnico.nome }}
            </b>
          </td>
        </tr>
        <tr class="table-secondary">
          <td colspan="2">
            Tipo de Atendimento: <b>{{ atendimento.tipo }}</b>
          </td>
        </tr>
        <tr
          class="table-secondary"
          v-if="atendimento.denuncias && atendimento.denuncias.length > 0"
        >
          <td colspan="2">
            Denúncias:

            <b
              class="mr-2"
              v-for="(denuncia, index) in atendimento.denuncias"
              :key="index"
            >
              <router-link
                v-if="denuncia"
                class="btn btn-sm btn-light py-0 px-1 my-1"
                :to="`/dashboard/denuncias/edit/${denuncia.id}`"
              >
                {{ denuncia.protocolo }}
              </router-link>
            </b>
          </td>
        </tr>
        <tr
          v-if="
            atendimento.relacao.length > 0 &&
            atendimento.relacao != null &&
            $route.meta.controller != atendimento.relacao.controller
          "
        >
          <td colspan="2">
            <span class="small" v-html="atendimento.relacao.mensagem"></span>
            <router-link :to="atendimento.relacao.link"> Ver </router-link>
          </td>
        </tr>
        <tr v-if="atendimento.demanda_reprimida_start">
          <td colspan="2"><b>DEMANDA REPRIMIDA:</b></td>
        </tr>
        <tr v-if="atendimento.demanda_reprimida_start">
          <td>
            <div>
              <b>Data de Inicio:</b>
              {{ atendimento.demanda_reprimida_start | formatDateHora() }}
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-between">
              <span
                ><b>Data de Final:</b>
                {{ atendimento.demanda_reprimida_end | formatDateHora() }}</span
              >
              <span class="badge badge-info">
                {{ atendimento.demanda_reprimida_tempo }} Dia(s)
                decorrido(s)</span
              >
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ["atendimento"],
};
</script>
